import api from "@/services/api";

const { put } = api.getPrefixedMethods("assignments");

const TARGET_KEYS = {
  submission: "orderKey",
  document: "intakeDocumentKey",
  order: "intakeOrderId",
};

export const assignmentsService = {
  /** Set one or both owner lists of a case; a null list leaves that kind of owner untouched. */
  setAssignees(entityType, entityId, userIds = null, groupIds = null) {
    const payload = { [TARGET_KEYS[entityType]]: entityId };
    if (userIds !== null) payload.userIds = userIds;
    if (groupIds !== null) payload.groupIds = groupIds;
    return put("", payload);
  },
};
